// priority 1...10
// blocker
// emergency

export const PriorityLightPalette: any = {
    1: '#4EC9F4',
    2: '#4EC9F4',
    3: '#71BBFF',
    4: '#71BBFF',
    // 5: '#7098FF',
    5: '#838EA0',
    6: '#FFAB66',
    7: '#FF8058',
    8: '#FF8058',
    9: '#FF8058',
    10: '#FF8058',
    50: '#F06462',
    100: '#F06462'
}


export const PriorityLightBorderPalette: any = {

    1: '#4DB9DF',
    2: '#4DB9DF',
    3: '#5DA7EC',
    4: '#5DA7EC',
    // 5: '#5D89F8',
    5: '#838EA0',
    6: '#FCA055',
    7: '#EE7650',
    8: '#EE7650',
    9: '#EE7650',
    10: '#EE7650',
    50: '#DA5C5A',
    100: '#DA5C5A',

}